import api from '../../../../../api/client';
import { PAYMENT } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

// export async function walletRecharge(formData) {
//   try {
//     const response = await api.post(PAYMENT.RECHARGE, formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     });
//     return handleApiResponse(response);
//   } catch (error) {
//     throw handleApiError(error);
//   }
// }

// export const walletRechargeApprove = async (payload = {}) => {
//   try {
//     const res = await api.post(PAYMENT.RECHARGE_APPROVE, payload);
//     return handleApiResponse(res);
//   } catch (err) {
//     throw handleApiError(err);
//   }
// };

export const initiateOnlineEnroll = async (payload = {}) => {
  try {
    const res = await api.post(PAYMENT.ENROLL_ONLINE, payload);
    return handleApiResponse(res);
  } catch (err) {
    throw handleApiError(err);
  }
};

// export const orderStatus = async (orderId) => {
//   try {
//     const res = await api.get(PAYMENT.ORDER_STATUS(orderId));
//     return handleApiResponse(res);
//   } catch (err) {
//     throw handleApiError(err);
//   }
// };
